<div class="form-container">
  <hau-form [formGroup]="form">
    <hau-form-field label="Name" [validation]="form.validation.name" cols="11">
      <input nbInput fullWidth formControlName="name">
    </hau-form-field>
    <hau-form-field label="Überholt" [validation]="form.validation.deprecated" cols="1">
      <nb-toggle formControlName="deprecated"></nb-toggle>
    </hau-form-field>
    <hau-form-field label="Farbe" [validation]="form.validation.color" cols="4">
      <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
    </hau-form-field>
    <hau-form-field label="Technische Einrichtung" [validation]="form.validation.facilityElements" cols="4">
      <wr-facility-element-multi-select formControlName="facilityElements"></wr-facility-element-multi-select>
    </hau-form-field>
    <hau-form-field label="Firma" [validation]="form.validation.tenantId" cols="4">
      <wr-tenant-select formControlName="tenantId" [tenantType]="'Internal'"></wr-tenant-select>
    </hau-form-field>
    <hau-form-field label="Beschreibung" [validation]="form.validation.description" cols="12">
      <textarea nbInput fullWidth formControlName="description"></textarea>
    </hau-form-field>
    <hau-form-field label="Icon (optional)" [validation]="form.validation.iconReference" cols="12">
      <wr-single-attachment-control [formControl]="form.controls.iconReference"
                                    type="IMAGE" singleAttachmentName="Icon (optional) löschen"></wr-single-attachment-control>
    </hau-form-field>
    <hau-form-field label="Bilder & Dokumentenliste" [validation]="form.validation.attachments" cols="12">
      <wr-multi-attachment-control formControlName="attachments"></wr-multi-attachment-control>
    </hau-form-field>
  </hau-form>
</div>
